import { EventBus } from '../events/eventbus'
import router from '../router/index'
const state = {
    staffMode: false,
    staffGuild: null,
}

const mutations = {
    ENABLESTAFFMODE(state, guildid) {
        state.staffMode = true
        state.staffGuild = guildid
    },
    DISABLESTAFFMODE(state) {
        state.staffMode = false
        state.staffGuild = null
    },
}

const actions = {
    toggleStaffMode({ commit }, guildId = undefined) {
        return new Promise((resolve, reject) => {
            router.push('/').catch(() => {})
            if (guildId != undefined) {
                EventBus.$emit('staffmode', guildId)
                commit('ENABLESTAFFMODE', guildId)
            } else {
                EventBus.$emit('staffmode', null)
                commit('DISABLESTAFFMODE')
            }
        })
    },
}

const getters = {
    isStaffMode: state => {
        return state.staffMode
    },
    staffGuild: state => {
        return state.staffGuild
    },
}

export default {
    state,
    mutations,
    getters,
    actions,
}



// WEBPACK FOOTER //
// ./src/stores/settings.js